import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import classnames from "classnames";
import Box from "@material-ui/core/Box";
import {
  BUSINESS,
  BUSINESS_CASH_MANAGEMENT_SOLUTION,
  BUSINESS_DEPOSIT,
  BUSINESS_FOREX_SERVICE,
  BUSINESS_INSURANCE,
  BUSINESS_INVESTMENT,
  BUSINESS_LOAN_SOLUTION,
} from "routes/paths";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  links: {
    textDecoration: "none",
  },
  menuMargin: {
    marginBottom: 20,
  },
  linkColor: {
    color: "initial",
  },
  smallFont: {
    fontSize: "12px",
  },
});

const creditcards = {
  mainpage: "Cards",
  type: [
    {
      typename: "Credit Card",
      pages: [
        {
          page: "Card Types",
          link: "/creditcards",
        },
        {
          page: "Promos",
          link: "/promos?p=Credit+Cards&cat=111",
        },
      ],
    },
    {
      typename: "Debit Card",
      pages: [
        {
          page: "Card Types",
          link: "/cards/debit-card",
        },
        {
          page: "Promos",
          link: "/promos/?p=Debit+Cards&cat=107",
        },
      ],
    },
    {
      typename: "Prepaid Card",
      pages: [
        {
          page: "Card Types",
          link: "/cards/prepaid-card",
        },
        {
          page: "Promos",
          link: "/promos",
        },
      ],
    },
  ],
};

const col2 = [
  {
    page: "Deposit",
    link: BUSINESS_DEPOSIT,
    type: "int",
    hasExtraSpaceUnder: false,
  },

  {
    page: "Cash Management",
    link: BUSINESS_CASH_MANAGEMENT_SOLUTION,
    type: "int",
    hasExtraSpaceUnder: false,
  },
  {
    page: "Business Loans",
    link: BUSINESS_LOAN_SOLUTION,
    type: "int",
    hasExtraSpaceUnder: false,
  },
  {
    page: "Investments and Trust",
    link: BUSINESS_INVESTMENT,
    type: "int",
    hasExtraSpaceUnder: false,
  },
  {
    page: "Forex Services",
    link: BUSINESS_FOREX_SERVICE,
    type: "int",
    hasExtraSpaceUnder: false,
  },
  {
    page: "Insurance",
    link: BUSINESS_INSURANCE,
    type: "int",
    hasExtraSpaceUnder: true,
  },
];

const col4 = [
  {
    page: "Corporate Information",
    link: "/about/whoweare",
  },
  {
    page: "Investor Relations",
    link: "/about/investorrelations",
  },
  {
    page: "Pressroom",
    link: "/about/newsroom",
  },
  {
    page: "Careers",
    link: "/about/careers",
  },
];

const col5 = [
  {
    page: "Terms of Use",
    link: "/termsofuse",
  },
  {
    page: "Privacy Statement",
    link: "/privacystatement",
  },
  {
    page: "Store and ATM Locator",
    link: "/storedirectory",
  },
  {
    page: "Contact Us",
    link: "/contactus",
  },
];

const RenderMenu = withStyles(styles)(function ({ classes, sitemap }) {
  return sitemap.map((menu, index) => {
    return (
      <Box className={classes.menuMargin} key={index}>
        {menu.isMainpageLink ? (
          menu.isMainPageLinkExternal ? (
            <Link
              className={classes.links}
              key={menu.mainpage}
              onClick={() => {
                window.open(menu.mainpageLink, "_blank");
              }}
            >
              <Typography
                variant="body2"
                gutterBottom
                color="primary"
                dangerouslySetInnerHTML={{ __html: menu.mainpage }}
              />
            </Link>
          ) : (
            <Link
              to={menu.mainpageLink}
              className={classes.links}
              key={menu.mainpage}
            >
              <Typography
                variant="body2"
                gutterBottom
                color="primary"
                dangerouslySetInnerHTML={{ __html: menu.mainpage }}
              />
            </Link>
          )
        ) : (
          <Typography
            variant="body2"
            gutterBottom
            color="primary"
            dangerouslySetInnerHTML={{ __html: menu.mainpage }}
          />
        )}
        {menu.pagemenu?.map((page) => {
          return page.type === "ext" ? (
            <a
              href={page.link}
              target="_blank"
              className={classes.links}
              style={{ color: "#000" }}
            >
              <Typography
                className={classes.smallFont}
                gutterBottom
                dangerouslySetInnerHTML={{ __html: page.page }}
              />
            </a>
          ) : (
            <Link
              to={page.link}
              className={classnames(classes.links, classes.linkColor)}
              key={page.page}
            >
              <Typography
                className={classes.smallFont}
                gutterBottom
                dangerouslySetInnerHTML={{ __html: page.page }}
              />
            </Link>
          );
        })}
      </Box>
    );
  });
});

class SitemapBusiness extends Component {
  state = {};
  render() {
    const { classes } = this.props;
    return (
      <Grid
        container
        spacing={0}
        justify="flex-start"
        className="gridContainer"
        style={{ paddingTop: "30px" }}
      >
        <Grid item md={1} lg={1}></Grid>
        <Grid item md={3}>
          <Box
            className={classes.menuMargin}
            display="flex"
            alignItems="center"
          >
            <img
              src="/images/2021/ewb-sitemap-icon.png"
              alt="contactus-icon"
              width="13%"
              style={{ marginRight: "10px" }}
            />
            <Typography variant="body1" gutterBottom color="primary">
              CONTACT US
            </Typography>
          </Box>

          <Typography
            className={classes.smallFont}
            gutterBottom
            color="primary"
          >
            We are happy to hear from you.
            <br />
            Feel free to get in touch with us if you
            <br /> have any requests, questions, or feedback
            <br /> concerning our services.
            <br />
            <br />
            {window.location.href.indexOf("creditcards") > -1 ? (
              <>
                For inquiries and feedback, you may call the
                <br />
                EastWest 24-Hour Customer Service Hotline
                <br />
                at (+632) 8888-1700, send an ​e-mail to
                cards@eastwestbanker.com,
                <br />
                or chat with EastWest System Tech Assistant
                <br />
                chatbot at www.ewlend.com/esta.
                <br />
                <br />
              </>
            ) : (
              <>
                For inquiries and feedback, you may call
                <br />
                our 24-Hour Customer Service
                <br />
                at (+632) 8888-1700 or email us at
                <br />
                service@eastwestbanker.com
                <br />
                <br />
              </>
            )}
          </Typography>
        </Grid>
        <Grid item md={3} container>
          <Box flexDirection="column">
            {col2.map((menu) => {
              return (
                <>
                  {menu.type === "ext" ? (
                    <a
                      href={menu.link}
                      target="_blank"
                      className={classes.links}
                      key={menu.page}
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="primary"
                        dangerouslySetInnerHTML={{ __html: menu.page }}
                        style={{ marginBottom: "15px" }}
                      />
                    </a>
                  ) : (
                    <Link
                      to={menu.link}
                      className={classes.links}
                      key={menu.page}
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="primary"
                        dangerouslySetInnerHTML={{ __html: menu.page }}
                        style={{ marginBottom: "15px" }}
                      />
                    </Link>
                  )}

                  {menu.hasExtraSpaceUnder ? <br /> : null}
                </>
              );
            })}
          </Box>
        </Grid>
        <Grid item md={3} container>
          <Box flexDirection="column">
            {col4.map((menu) => {
              return (
                <>
                  {menu.type === "ext" ? (
                    <a
                      href={menu.link}
                      target="_blank"
                      className={classes.links}
                      key={menu.page}
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="primary"
                        dangerouslySetInnerHTML={{ __html: menu.page }}
                        style={{ marginBottom: "15px" }}
                      />
                    </a>
                  ) : (
                    <Link
                      to={menu.link}
                      className={classes.links}
                      key={menu.page}
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="primary"
                        dangerouslySetInnerHTML={{ __html: menu.page }}
                        style={{ marginBottom: "15px" }}
                      />
                    </Link>
                  )}

                  {menu.hasExtraSpaceUnder ? <br /> : null}
                </>
              );
            })}
          </Box>
        </Grid>
        <Grid item md={2} container>
          <Box flexDirection="column">
            {col5.map((menu) => {
              return (
                <>
                  {menu.type === "ext" ? (
                    <a
                      href={menu.link}
                      target="_blank"
                      className={classes.links}
                      key={menu.page}
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="primary"
                        dangerouslySetInnerHTML={{ __html: menu.page }}
                        style={{ marginBottom: "15px" }}
                      />
                    </a>
                  ) : (
                    <Link
                      to={menu.link}
                      className={classes.links}
                      key={menu.page}
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="primary"
                        dangerouslySetInnerHTML={{ __html: menu.page }}
                        style={{ marginBottom: "15px" }}
                      />
                    </Link>
                  )}

                  {menu.hasExtraSpaceUnder ? <br /> : null}
                </>
              );
            })}
          </Box>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(SitemapBusiness);
